export default {
  // Endpoints
  loginEndpoint: '/Auth/Login',
  tokenType: 'Bearer',
  storageTokenKeyName: 'token'
}
